const getImageFileSizeFromUrl = async (url) => {
  try {
    const headResponse = await fetch(url, { method: 'HEAD' });

    if (headResponse.ok) {
      const contentLength = headResponse.headers.get('content-length');

      if (contentLength) {
        return parseInt(contentLength, 10);
      }
    }
  } catch (error) {
    console.error(error);
  }

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error('Failed to fetch image');
  }

  const blob = await response.blob();

  return blob.size;
};

export default getImageFileSizeFromUrl;
